module.exports = __webpack_public_path__ + "img/access.d18382e8.jpg";